import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions from '~/Actions';
import { EAA_Item, EAA_ItemContainer, EAA_Input, EAA_ErrorText, EAA_Row, EAA_TitleText, EAA_Memo, EAA_Btn, EAA_Select } from '~/components/EditAndAddItem';
import { rightColor, leftColor } from '~/components/EditAndAddItem/common';
import PageTitle from '~/components/PageTitle';
import AddRes from '~/components/Dialog/AddRes';
import EditRes from '~/components/Dialog/EditRes';
import { re_email, re_num } from '~/skills/TextRules';

const modeInfo = {
  '': { title: '' },
  add: {
    title: '組織新增',
  },
  edit: {
    title: '組織編輯',
  },
  view: {
    title: '組織檢視',
  },
};

class AddAndEdit extends Component {
  state={ mode: '', orgIdData: {}, old_orgIdData: {}, canSend: true, errorAry: [] }
  componentDidMount () {
    const { id = '', getOrgIdDetail, mode = '', setPageText, getWindList } = this.props;
    setPageText(modeInfo[mode].title);
    if (id.length > 0)getOrgIdDetail(id);
    getWindList();
  }

  componentDidUpdate (preProps) {
    // const { preOrgIdDetail } = preProps;
    const { orgIdDetail = {} } = this.props;
    const { orgIdData = {} } = this.state;
    if (Object.keys(orgIdData).length === 0 && Object.keys(orgIdDetail).length > 0) {
      this.setState({ orgIdData: orgIdDetail, old_orgIdData: orgIdDetail });
    }
  }

  componentWillUnmount () {
    this.props.clearOrgIdDetail();
    this.props.clearKey('PageText');
  }

  _onClose=() => {
    this.props._onClose();
  }

  changeData=({ label = '', data = '' }) => {
    const { orgIdData: body } = this.state;
    const orgIdData = JSON.parse(JSON.stringify(body));
    orgIdData[label] = data;
    this.setState({ orgIdData });
  }

  add=() => {
    this.setState({ canSend: false });
    const { orgIdData: d } = this.state;
    const orgIdData = JSON.parse(JSON.stringify(d));
    this.props.postAddNewOrg(orgIdData);
  }

  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] });
  edit=() => {
    this.setState({ canSend: false });
    const { id, putUpdateOrg } = this.props;
    const { orgIdData } = this.state;
    const body = {};
    for (let i = 0; i < Object.keys(orgIdData).length; i++) {
      body[Object.keys(orgIdData)[i]] = orgIdData[Object.keys(orgIdData)[i]] || '';
    }
    putUpdateOrg(id, body);
  }

  filterError=() => {
    const { orgIdData = {} } = this.state;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const errorAry = [
      returnInputValue(orgIdData.name) === '',
      false, // returnInputValue(orgIdData.oid) === '',
      !re_num(returnInputValue(orgIdData.order)),
      // returnInputValue(orgIdData.order) === '',
      returnInputValue(orgIdData.contact_email).length > 0 && !re_email(orgIdData.contact_email),
      (orgIdData.windcontracts || []).length === 0,
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

  render () {
    const { mode = '', windList = [] } = this.props;
    const { orgIdData = {}, old_orgIdData = {}, canSend, errorAry } = this.state;
    const isCheck = this.state.mode === 'check';
    const disabled = mode === 'view' || isCheck;
    const checkChange = label => isCheck ? (orgIdData[label] || '') !== (old_orgIdData[label] || '') : false;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const allRight = errorAry.indexOf(true) === -1;

    return (
      <div style={{
        position: 'absolute',
        left: 13,
        right: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        overflow: 'auto',
      }}
      >

        <PageTitle text={modeInfo[mode].title} />
        <div style={{ height: 8 }} />

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='組織名稱' bol={true} haveChange={checkChange('name')} />
              <EAA_Input displayBorder disabled={disabled} hint='請填入組織單位名稱' value={returnInputValue(orgIdData.name)} onChange={data => { this.changeData({ label: 'name', data }); }} />
            </EAA_ItemContainer>
            {errorAry[0] && <EAA_ErrorText text='請輸入。' />}
          </EAA_Item>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='排序值' bol={true} haveChange={checkChange('order')} />
              <EAA_Input displayBorder disabled={disabled} hint='0' value={returnInputValue(orgIdData.order)} onChange={data => { this.changeData({ label: 'order', data }); }} />
            </EAA_ItemContainer>
            {errorAry[2] && <EAA_ErrorText text='請輸入排序值。(純數字)' />}
          </EAA_Item>
        </EAA_Row>
        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='風場合約' bol={true} haveChange={JSON.stringify(orgIdData.windcontracts || []) !== JSON.stringify(old_orgIdData.windcontracts || [])} />
              <EAA_Select displayBorder disabled={disabled} multiple list={windList} value={orgIdData.windcontracts || []} onChange={data => { this.changeData({ label: 'windcontracts', data }); }} />
            </EAA_ItemContainer>
            {errorAry[4] && <EAA_ErrorText text='請選擇' />}
          </EAA_Item>
        </EAA_Row>
        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='聯絡人' haveChange={checkChange('contact_name')} />
              <EAA_Input displayBorder disabled={disabled} hint='請填入聯絡人姓名' value={returnInputValue(orgIdData.contact_name)} onChange={data => { this.changeData({ label: 'contact_name', data }); }} />
            </EAA_ItemContainer>
            {/* {errorAry[3] && <EAA_ErrorText text='請填入聯絡人姓名' />} */}
          </EAA_Item>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='職稱' haveChange={checkChange('contact_title')} />
              <EAA_Input displayBorder disabled={disabled} hint='請填入聯絡人職稱' value={returnInputValue(orgIdData.contact_title)} onChange={data => { this.changeData({ label: 'contact_title', data }); }} />
            </EAA_ItemContainer>
            {/* <EAA_ErrorText text='請輸入行動電話。' /> */}
          </EAA_Item>
        </EAA_Row>
        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='電話' haveChange={checkChange('contact_tel_number')} />
              <EAA_Input displayBorder disabled={disabled} hint='請填入聯絡人電話' value={returnInputValue(orgIdData.contact_tel_number)} onChange={data => { this.changeData({ label: 'contact_tel_number', data }); }} />
            </EAA_ItemContainer>
            {/* {errorAry[3] && <EAA_ErrorText text='請填入聯絡人姓名' />} */}
          </EAA_Item>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='電子信箱' haveChange={checkChange('contact_email')} />
              <EAA_Input displayBorder disabled={disabled} hint='請填入聯絡人Email' value={returnInputValue(orgIdData.contact_email)} onChange={data => { this.changeData({ label: 'contact_email', data }); }} />
            </EAA_ItemContainer>
            {errorAry[3] && <EAA_ErrorText text='信箱格式錯誤' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'row' }}>
            <EAA_TitleText text='備註說明' haveChange={checkChange('memo')} />
            <EAA_Memo displayBorder disabled={disabled} hint='例如: 備註此組織記事' value={returnInputValue(orgIdData.memo)} onChange={data => this.changeData({ label: 'memo', data })} />
          </div>
        </EAA_Row>

        <div style={{ height: 16 }} />

        <div style={{ display: 'flex', marginTop: 36, width: '100%', justifyContent: 'center', marginBottom: 40 }}>
          {mode === 'add' && !isCheck && <EAA_Btn text='取消' backgroundColor={leftColor} onClick={this._onClose} />}
          {mode === 'add' && !isCheck && <EAA_Btn text='確認' backgroundColor={rightColor} onClick={this.goToCheck} style={{ marginLeft: 16 }} />}
          {mode === 'add' && isCheck && <EAA_Btn text='返回編輯' backgroundColor={leftColor} onClick={this.goToEdit} />}
          {mode === 'add' && isCheck && <EAA_Btn text='確認新增' backgroundColor={(allRight && canSend) ? rightColor : 'gray'} onClick={this.add} style={{ marginLeft: 16 }} disabled={!allRight || !canSend} />}
          {mode === 'edit' && !isCheck && <EAA_Btn text='取消' backgroundColor={leftColor} onClick={this._onClose} />}
          {mode === 'edit' && !isCheck && <EAA_Btn text='確認' backgroundColor={rightColor} onClick={this.goToCheck} style={{ marginLeft: 16 }} />}
          {mode === 'edit' && isCheck && <EAA_Btn text='返回編輯' backgroundColor={leftColor} onClick={this.goToEdit} />}
          {mode === 'edit' && isCheck && <EAA_Btn text='確認修改' backgroundColor={(allRight && canSend) ? rightColor : 'gray'} onClick={this.edit} style={{ marginLeft: 16 }} disabled={!allRight || !canSend} />}
          {mode === 'view' && <EAA_Btn text='返回' backgroundColor={leftColor} onClick={this._onClose} />}
        </div>

        <AddRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PostAddNewOrg' />
        <EditRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PutUpdateOrg' />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  orgIdDetail: state.data.OrgIdDetail,
  windList: state.data.WindList,
});
const mapDispatchToProps = dispatch => ({
  clearKey: key => Actions.clearKey(dispatch, { key }),
  setPageText: text => Actions.setPageText(dispatch, { text }),
  getOrgIdDetail: id => Actions.getOrgIdDetail(dispatch, { id }),
  getWindList: () => Actions.getWindList(dispatch),
  clearOrgIdDetail: () => Actions.clearKey(dispatch, { key: 'OrgIdDetail' }),
  postAddNewOrg: body => Actions.postAddNewOrg(dispatch, { body }),
  putUpdateOrg: (id, body) => Actions.putUpdateOrg(dispatch, { id, body }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddAndEdit);
